"use client"
import Link from "next/link"
import { Mail } from "lucide-react"
import { Separator } from "@/components/ui/separator"

export function Footer() {
  return (
    <footer className="bg-muted/30 border-t">
      <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16 py-12 lg:py-16 xl:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 xl:gap-16">
          {/* 1. Shop - Main Navigation */}
          <div className="space-y-3 lg:space-y-4">
            <div className="font-semibold mb-2">Shop</div>
            <div className="flex flex-col space-y-2">
              <Link href="/shop" className="hover:underline cursor-pointer">Shop All</Link>
              <Link href="/about" className="hover:underline cursor-pointer">About Us</Link>
              <Link href="/contact" className="hover:underline cursor-pointer">Contact Us</Link>
            </div>
          </div>
          {/* 2. Policies - Legal */}
          <div className="space-y-3 lg:space-y-4">
            <div className="font-semibold mb-2">Policies</div>
            <div className="flex flex-col space-y-2">
              <Link href="/privacy" className="hover:underline">Privacy Policy</Link>
              <Link href="/terms" className="hover:underline">Terms of Service</Link>
              <Link href="/shipping-policy" className="hover:underline">Shipping Policy</Link>
              <Link href="/return-policy" className="hover:underline">Return Policy</Link>
            </div>
          </div>
          {/* 3. Connect */}
          <div className="space-y-3 lg:space-y-4">
            <div className="font-semibold mb-2">Connect</div>
            <div className="flex flex-col space-y-2 body-medium text-muted-foreground">
              <Link href="https://www.youtube.com/@aepacit" target="_blank" rel="noopener noreferrer" aria-label="Watch us on YouTube" className="hover:underline flex items-center gap-2">
                <img src="/youtube-play.png" alt="Watch on YouTube" className="h-6 w-6" />
                <span>Watch on YouTube</span>
              </Link>
              <a href="mailto:contactanjalienterprises@gmail.com" className="hover:underline flex items-center gap-2">
                <Mail className="h-4 w-4 lg:h-5 lg:w-5" />
                <span>contactanjalienterprises@gmail.com</span>
              </a>
            </div>
          </div>
        </div>

        <Separator className="my-8 lg:my-12 xl:my-16" />

        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 lg:space-y-6 md:space-y-0">
          <div className="body-medium text-muted-foreground text-center md:text-left">
            © {new Date().getFullYear()} AEPAC. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  )
}
